import React from 'react'
import {Dropdown} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import DeleteActions from "./delete-actions";

type Props = {
    item: any
    update: () => void
    type: string
}

const TemplateAction = (props: Props) => {
    const {t} = useTranslation()
    return <Dropdown autoClose="outside">
        <Dropdown.Toggle variant="light" id="dropdown-basic">
            <i className="fa-solid fa-ellipsis-vertical"></i>
        </Dropdown.Toggle>

        <Dropdown.Menu>
            <DeleteActions {...props}/>
        </Dropdown.Menu>
    </Dropdown>
}

export default TemplateAction